import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Awards/OurSuccess/OurSuccess.css";

const ImageGallery = () => {
  return (
    <>
      <div className="our-success-back" style={{ marginBottom: "-178px" }}>
        <div className="container">
          <div className="row our-success px-md-5 px-4">
            <h1 className="headings text-center mb-md-5 mb-3 text-uppercase">
              <span>Snapshots </span>of Our Success
            </h1>
            <div className="col-md-2 images-height col-width1">
              <div className="d-flex flex-column gap-2">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/CulturePhotosJaipur/_DSC3038.jpg"
                  alt=""
                  className="sucess1-img"
                  loading="lazy"
                />
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/images/CulturePhotosJaipur/1.jpg"
                  alt=""
                  className="sucess1-img succes-img1"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-md-6 images-height pe-0 col-width2">
              <LazyLoadImage
                effect="blur"
                src="https://blueberrywebsites.azureedge.net/bbt/images/CulturePhotosJaipur/_DSC3052.jpg"
                alt=""
                className="succes3-img success-img2"
                loading="lazy"
              />
            </div>
            <div className="col-md-4 images-height ps-2 col-width3">
              <div className="row">
                <div className="col-md-6">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/images/CulturePhotosJaipur/_DSC3113.jpg"
                    alt=""
                    className="succes2-img success-img3"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-6 ">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/images/CulturePhotosJaipur/IMG_1898.jpg"
                    alt=""
                    className="succes2-img success-img4"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/images/CulturePhotosJaipur/_DSC3220.jpg"
                    alt=""
                    className="succes2-img success-img5"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageGallery;
